import React from "react";
import "./Hero.scss";

const Hero: React.FC = () => {
  return (
    <div className="Hero-section">
      <div className="hero-title">Your Hay, On The Way!</div>
    </div>
  );
};

export default Hero;
